import React from 'react';
import { Shield, Lock, FileText } from 'lucide-react';

const Compliance = () => {
  const complianceFocus = [
    'India-registered private limited company',
    'Statutory audit and annual filings maintained as required',
    'GST-compliant invoicing where applicable',
    'Written records prioritized over informal communication'
  ];

  const dataConfidentiality = [
    'Candidate and client information handled confidentially on a need-to-know basis',
    'Information sharing governed by contractual obligations',
    'Security measures aligned to contractual requirements and reasonable administrative controls'
  ];

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-slate-50 to-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">Compliance & Governance</h1>
            <p className="text-xl text-gray-600">
              Documentation-driven processes aligned with statutory requirements.
            </p>
          </div>
        </div>
      </section>

      {/* Compliance Focus */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="flex items-center justify-center mb-8">
          <Shield size={32} className="text-blue-900 mr-4" />
          <h2 className="text-3xl font-bold text-gray-900">Compliance Focus</h2>
        </div>
        <div className="max-w-3xl mx-auto space-y-4">
          {complianceFocus.map((item, index) => (
            <div key={index} className="flex items-start bg-gray-50 p-6 rounded-lg border border-gray-200">
              <div className="w-2 h-2 bg-blue-900 rounded-full mt-2 mr-4 flex-shrink-0"></div>
              <p className="text-lg text-gray-700">{item}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Data & Confidentiality */}
      <section className="bg-gray-50 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center mb-8">
            <Lock size={32} className="text-blue-900 mr-4" />
            <h2 className="text-3xl font-bold text-gray-900">Data & Confidentiality</h2>
          </div>
          <div className="max-w-3xl mx-auto space-y-4">
            {dataConfidentiality.map((item, index) => (
              <div key={index} className="flex items-start bg-white p-6 rounded-lg border border-gray-200">
                <FileText size={20} className="text-blue-900 mr-3 mt-1 flex-shrink-0" />
                <p className="text-lg text-gray-700">{item}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Important Notice */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-blue-50 border-l-4 border-blue-900 p-6 rounded">
          <p className="text-sm text-gray-700">
            <strong>Note:</strong> BRX Resource does not claim ISO, SOC2, or HIPAA certification. Security and compliance measures are implemented in accordance with contractual obligations and reasonable administrative controls appropriate to the nature of services provided.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Compliance;